import { Component } from "@angular/core";
import { ShareWrapper } from "./share-wrapper.component";
import { Asset } from 'globals/store/assets.data';
import { environment } from "../../../environments/environment";
import { ActivatedRoute } from "@angular/router";
import { BudgetQuoteShareSection } from "../../store/reselectors/budget.data";
import { getGridDataFromSection, scheduleToScheduleGridData } from "../../store/reselectors/budget.reselector.helpers";
import { BudgetSectionGridData, PaymentGridData } from "../../helpers/grid-helpers";
import { urlIsValid } from "../../helpers/helpers";
import { BrandingData } from "globals/store/publish.data";
import { BrandingWrapperComponent } from "src/app/components/branding/branding-wrapper.component";
import { ActionButtonComponent } from "src/app/components/nav-bar/action-button.component";
import { BudgetSectionComponent } from "../budget/budget-section.component";
import { CommonModule } from "@angular/common";
import { JoiInputComponent } from "src/app/components/joi-input/joi-input.component";
import { InputEditorComponent } from "src/app/components/joi-input/input-editor";
import { FileLinkComponent } from "src/app/components/file-handler/file-link.component";
import { TipTextComponent } from "src/app/components/misc/tip-text.component";
import { updateBudgetSectionInPlace } from "globals/helpers/budget.helper";
import { Subject } from "rxjs";


@Component({
    selector: 'share-quote',
    template: ` 
<branding-wrapper 
  [brandingData]="brandingData" 
    [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div class="content">
    <div *ngIf="loading" class="loading">Loading...</div>
    <div *ngIf="!loading && !quote"  class="sorry" [innerHTML]="helpers.strWithBreak(helpers.strWithBreak(unavailableMessage))"></div>
    <div *ngIf="submitted"  class="thanks" [innerHTML]="helpers.strWithBreak(resultMessage)"></div>
    <ng-container *ngIf="!submitted && !!quote">
      <h3 class="event-name">{{ quote.eventName }}</h3>
      <h5 class="event-date" *ngIf="!!quote.eventDateString">{{ quote.eventDateString }}</h5>
      <div class="deadline" *ngIf="!!quote.submissionDeadline">
        <div style="flex:1"></div>
        <div class="title">SUBMISSION DEADLINE: </div>
        <div class="date">{{ quote.submissionDeadline | date:"EEEE d LLLL y" }}</div>
      </div>
      <hr />
      <tip-text  [type]="'tip'" [head]="'Tip:'" [body]="'Instructions: Please provide a link to your quote and a summary in the section below. Before completing the section please check SECTION SETTINGS'"></tip-text>

      <div class="quote-info">
        <div class="left">
          <joi-input #sectionTitle class="big-title" [type]="'textarea'" [(model)]="quote.name" [placeholder]="'Quote Name...'" (joiChange)="updateQuote();" ></joi-input>
          <h5>NOTES / DESCRIPTION</h5>
          <input-editor 
            class="quote-notes"
            [object]="quote" 
            [forceSave]="forceSave" 
            [prop]="'notes'" 
            [placeholder]="'Quote notes / description...'"
          ></input-editor>
        </div>
        <div class="right">
          <div class="info-line">
            <div class="field-name">Quote Ref #: </div>
            <div style="flex:1"></div>
            <joi-input
              [fixedWidth]="true"
              [(model)]="quote.quoteRef" 
              [placeholder]="'Reference no...'"
            ></joi-input> 
          </div>
          <div class="info-line">
            <div class="quote-link field-name">
              Quote Link: 
              <div class="invalid" *ngIf="!!linkInvalid">Link is invalid (needs to start with http(s)://)</div>
            </div>
            <div style="flex:1"></div>
            <div class="link-holder">
              <joi-input  
                [(model)]="quote.quoteLink"
                [fixedWidth]="true"
                [placeholder]="'Link to quote...'"
              ></joi-input>
              <file-link *ngIf="!linkInvalid && !!quote.quoteLink" [onlyLink]="true" [onlyOpenInNew]="true" [file]="{ linkUrl: quote.quoteLink }"></file-link>
            </div>
          </div>
          <div style="flex:1"></div>
        </div>
      </div>

      <budget-section *ngIf="!!quote"
        [section]="quote"
        [budgetCurrency]="quote.budgetCurrency"
        [hideTitle]="true"
        [isRevenue]="false"
        [single]="true"
        [public]="true"
        [gridData]="gridData"
        [scheduleGridData]="scheduleGridData"
        (saveSection)="updateQuote()"
      ></budget-section>
      <div class="error-holder" *ngIf="error" [innerHTML]="helpers.strWithBreak(error)"></div>

      <action-button class="submit" [text]="'SUBMIT'" [disabled]="linkInvalid" (click)="submitQuote()"></action-button>
    </ng-container>
  </div>
</branding-wrapper>
  `,
    styles: [`
  `],
    styleUrls: ['./share-quote.scss', '../resources/manage-quote.scss'],
    standalone: true,
    imports: [BrandingWrapperComponent, ActionButtonComponent, BudgetSectionComponent, CommonModule, JoiInputComponent, InputEditorComponent, FileLinkComponent, TipTextComponent]
})
export class ShareQuoteComponent extends ShareWrapper<ShareQuoteComponent> {
  forceSave: Subject<void> = new Subject<void>();

  readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
  id:string;
  eventId: string
  quote: BudgetQuoteShareSection
  processing:boolean;
  loading: boolean
  disabled = true
  submitted:boolean;
  error: string
  linkInvalid: boolean = false

  asset: Asset = {}
  submitterForAnyone = { name: '' }
  cannotSubmitMessage = "The quote can't be submitted at this time.\n\nPlease reload this page and try again."
  unavailableMessage = `The quote submission area is currently not available.\n\nPlease contact the event organiser.`
  resultMessage = "Thank you"
  scheduleGridData: PaymentGridData[]
  gridData: BudgetSectionGridData[]
  brandingData: BrandingData

  getGridDatas() {
    this.gridData = getGridDataFromSection(this.quote,this.quote.budgetCurrency),
    this.scheduleGridData = scheduleToScheduleGridData(this.quote.schedule, this.quote.total)
  }


  constructor(private route:ActivatedRoute) {
    super()
    this.loading = true;
    document.title = "loading";
    this.route.params.subscribe(params=>{
      if(!params || !params.hasOwnProperty('id')) {
        this.loading = false;
        document.title = "Unavailable";
      } else {
        const { id } = params;
        this.id = id
        const url = `${this.api}/load-share-quote/${id}`
        this.take1(this.http.get(url)).then((data: BudgetQuoteShareSection) => {
          console.log({ data })
          this.quote = data
          this.updateQuote()
          this.loading = false
          this.brandingData = data.brandingData
          document.title = "Submit Quote"
        }, (error) => {
          console.log(error)
          this.loading = false;
          document.title = "Quote Submission Unavailable";
        });
      }
    })
  }

  submitQuote() {
    this.processing = true;
    this.forceSave.next();
    this.take1(this.http.post(`${this.api}/submit-quote`, this.quote)).then((data:any) => {
      this.processing = false;
      this.submitted = true;
    }, error => {
      console.error({ error })
      this.processing = false;
      this.showError(error.error)
    });
  }

  checkLink() {
    this.linkInvalid = !urlIsValid(this.quote.quoteLink)
    console.log({ linkInvalid: this.linkInvalid })
  }

  updateQuote() {
    updateBudgetSectionInPlace(this.quote, this.quote.budgetCurrency)
    this.checkLink()
    this.getGridDatas()
  }

}
